import {
  createMutationKeys,
  createQueryKeys,
  mergeQueryKeys,
} from '@lukemorales/query-key-factory'
import { APIAxiosInstance } from '@core/utils/api-axios-instance'
import { createQueryKeyString } from '@core/react-query/queryParams'
import { RequestTypes } from '@core/react-query/features/dashboard'

const dashboardQueryKeys = createQueryKeys('dashboard', {
  getDashboardPermitStats: (
    payload: RequestTypes['getDashboardPermitStats'],
  ) => {
    return {
      queryKey: [
        payload.organisationId,
        payload.projectId,
        payload.processTagIds,
        payload.locationIds,
      ],
      queryFn: async () => {
        const { data } = await APIAxiosInstance.get(
          `permits/stats${createQueryKeyString(payload)}`,
        )

        return data
      },
    }
  },
  getDashboardInspectionStats: (
    payload: RequestTypes['getDashboardInspectionStats'],
  ) => {
    return {
      queryKey: [
        payload.organisationId,
        payload.projectId,
        payload.processTagIds,
        payload.locationIds,
      ],
      queryFn: async () => {
        const { data } = await APIAxiosInstance.get(
          `inspections/stats${createQueryKeyString(payload)}`,
        )

        return data
      },
    }
  },
  getDashboardObservationStats: (
    payload: RequestTypes['getDashboardObservationStats'],
  ) => {
    return {
      queryKey: [
        payload.organisationId,
        payload.projectId,
        payload.locationIds,
      ],
      queryFn: async () => {
        const { data } = await APIAxiosInstance.get(
          `observations/stats${createQueryKeyString(payload)}`,
        )

        return data
      },
    }
  },
})

const dashboardMutationKeys = createMutationKeys('dashboard', {})

export const dashboardKeys = mergeQueryKeys(
  dashboardQueryKeys,
  dashboardMutationKeys,
).dashboard
